import {
  Avatar,
  Button,
  Heading,
  HStack,
  Icon,
  Stack,
  Text,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import {
  getUserDetails,
  updateProfileImage,
} from '../../stores/slices/user/userActions';
import Card from '../Card';
import FileUpload from '../FileUpload';
import { MdMailOutline } from 'react-icons/md';
import { CgOrganisation } from 'react-icons/cg';
import { getCurrentUserInfo } from '../../utils/getCurrentUserInfo';

const ProfileImage = () => {
  const { userInfo,assumedUserInfo,
    isAssumed, } = useSelector(state => state.user);
  const currentUser = getCurrentUserInfo({
    assumedUserInfo,
    isAssumed,
    userInfo,
  });
  const dispatch = useDispatch();
  const toast = useToast();
  const [preview, setPreview] = useState(null);

  const schema = yup
    .object({
      image: yup.mixed().required('Attachment is required'),
    })
    .required();
  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const selectedFile = watch('image', null);

  useEffect(() => {
    if (!selectedFile) {
      setPreview(currentUser.image?.url);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile, currentUser.image]);

  const onSave = async data => {
    const formData = new FormData();
    formData.append('user[image]', data.image);
    const res = await dispatch(
      updateProfileImage({ formData, id: currentUser.id })
    );
    if (res.type === 'user/updateProfileImage/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      dispatch(getUserDetails());
      toast({
        description: 'Account details updated',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };

  return (
    <Card mx={'auto'} h={'full'} px={{ base: 4, md: 10 }}>
      <form onSubmit={handleSubmit(onSave)}>
        <Stack
          direction={{ base: 'column', lg: 'row' }}
          justifyContent={'start'}
          spacing={{ base: 4, lg: 10 }}
        >
          <Avatar
            size="2xl"
            showBorder
            borderColor={'primary'}
            borderWidth={'medium'}
            name={currentUser.full_name}
            loading={'lazy'}
            src={preview}
            alignSelf={'center'}
          />
          <VStack alignItems={'start'}>
            <Heading as="h4" size="md">
              {currentUser.full_name}
            </Heading>
            <HStack>
              <Icon as={MdMailOutline} w={4} h={4} color={'primary'} />
              <Text>{currentUser.email}</Text>
            </HStack>
            <HStack>
              <Icon as={CgOrganisation} w={4} h={4} color={'primary'} />
              <Text>
                {currentUser.organisation
                  ? currentUser.organisation.name
                  : 'No Organisation'}
              </Text>
            </HStack>

            <HStack w={'full'} pt={'2'} alignItems={'start'}>
              <FileUpload
                name="image"
                acceptedFileTypes="image/jpg, image/jpeg, image/gif, image/png"
                placeholder="Choose File"
                control={control}
                {...register('image')}
              />{' '}
              <Button type="submit" isLoading={isSubmitting}>
                Save
              </Button>
            </HStack>
          </VStack>
        </Stack>
      </form>
    </Card>
  );
};

export default ProfileImage;
